import React, { FC } from 'react'
import { Chip, Paper } from '@mui/material'
import { DataGridPremium, GridColDef } from '@mui/x-data-grid-premium'
import { ContractorTransferConflict, ContractorTransferConflictSeverityEnum } from 'src/api'
import { TableToolbar } from 'src/components/ui'

interface ConflictRow extends ContractorTransferConflict {
  id: number
}

const columns: GridColDef<ConflictRow>[] = [
  {
    field: 'severity',
    headerName: 'Severity',
    minWidth: 110,
    sortable: false,
    renderCell: ({ value }) => (
      <Chip
        size="small"
        label={value === ContractorTransferConflictSeverityEnum.Blocking ? 'Blocking' : 'Warning'}
        color={value === ContractorTransferConflictSeverityEnum.Blocking ? 'error' : 'warning'}
      />
    )
  },
  { field: 'code', headerName: 'Code', minWidth: 300, sortable: false },
  { field: 'label', headerName: 'Subject', minWidth: 200, sortable: false, valueGetter: ({ row }) => row.label || '-' },
  { field: 'message', headerName: 'Message', minWidth: 320, flex: 1, sortable: false }
]

interface ContractorTransferConflictListProps {
  conflicts: ContractorTransferConflict[]
  exportedFileName: string
}

/** The blocking errors and warnings of a preview or a transfer, in one grid that exports to CSV. */
export const ContractorTransferConflictList: FC<ContractorTransferConflictListProps> = ({ conflicts, exportedFileName }) => {
  const rows: ConflictRow[] = conflicts.map((conflict, index) => ({ ...conflict, id: index }))

  return (
    <Paper sx={{ width: '100%', minWidth: 0 }}>
      <DataGridPremium<ConflictRow>
        rows={rows}
        columns={columns}
        autoHeight
        disableRowSelectionOnClick
        getRowHeight={() => 'auto'}
        pagination
        initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
        pageSizeOptions={[25, 50, 100]}
        slots={{ toolbar: () => <TableToolbar exportedFileName={exportedFileName} /> }}
        sx={{ border: 'none', '& .MuiDataGrid-cell': { py: 1 } }}
      />
    </Paper>
  )
}
